module.exports = __webpack_public_path__ + "img/icon2.e60b4cd0.png";